import { Card } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { Overlay } from '@eti/components';
import useNameFormatter from '../../../../common/custom-hooks/useNameFormatter';
import { TravelerNames } from './CartProduct';

const travelerNamesStyles = css`
  margin-top: 16px;
`;
const cardStyles = css`
  overflow-x: auto;
`;
const textStyles = css`
  white-space: pre;
`;

interface CartProductOverlayProps {
  onClose: () => void;
  isOpen: boolean;
  text: string;
  title: string;
  travelers: {
    firstName: string;
    lastName: string;
  }[];
}

const CartProductOverlay = ({
  onClose,
  isOpen,
  text,
  title,
  travelers,
}: CartProductOverlayProps) => {
  const { t } = useTranslation();
  const contentHeaderText = t('Product.ReadMoreOverlay.ContentHeader.Label');
  const { formatName } = useNameFormatter();

  return (
    <Overlay.Drawer dataTestId="cartProduct-overlay" handleClose={onClose} isOpen={isOpen}>
      <Overlay.Header onClose={onClose} title={title} />
      <Overlay.Content data-testid="cartProduct-overlay-content">
        <Card className={cardStyles}>
          {contentHeaderText && <Overlay.CardTitle>{contentHeaderText}</Overlay.CardTitle>}
          <div className={textStyles}>{text}</div>
          {travelers?.length > 0 && (
            <TravelerNames className={travelerNamesStyles}>
              {travelers.map(({ firstName, lastName }) => (
                <div key={`${firstName}-${lastName}`}>{formatName(firstName, lastName)}</div>
              ))}
            </TravelerNames>
          )}
        </Card>
      </Overlay.Content>
    </Overlay.Drawer>
  );
};

export default CartProductOverlay;
